const handleSearchOverlayToggle = () => {
    const btn = document.getElementById('search-btn');
    const serachOverlay = document.querySelector(".search_overlay");
    const header = document.querySelector(".header");
    if (btn && serachOverlay) {
        btn.addEventListener('click', () => {
            serachOverlay.setAttribute("style", "display: block;");
            let btnClose = document.getElementById('close-btn');
            header.classList.add("header_sticky");
            btnClose.addEventListener('click', () => {
                serachOverlay.setAttribute("style", "display: none;");
                header.classList.remove("header_sticky");

            })
        });
    }
}
export default handleSearchOverlayToggle;
